import { Component, OnDestroy } from '@angular/core';
import { AssetFieldValue } from '@classes/AssetFieldValue';
import { FileReference } from '@classes/FileReference';
import { FileReferenceService } from '@services/file-reference.service';
import { Modal } from 'bootstrap';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-show-asset-files',
  templateUrl: './show-asset-files.component.html',
  styleUrls: ['./show-asset-files.component.css'],
  standalone: false
})
export class ShowAssetFilesComponent implements OnDestroy {
  public cancelText = 'Cancel'
  public modal: Modal
  public title = 'Modal Title'

  private _assetFieldValue: AssetFieldValue
  get assetFieldValue() { return this._assetFieldValue }
  set assetFieldValue(afv: AssetFieldValue) {
    this.revokeObjectUrls()
    this.fileURLMap = {}
    this._assetFieldValue = afv
    this.fileReferences = afv.fileReferences
  }

  private _fileReferences: FileReference[]
  get fileReferences() { return this._fileReferences}
  set fileReferences(fileReferences: FileReference[]) {
    this._fileReferences = fileReferences
    this.registerFileURL(this.fileReferences)
  }

  private fileURLMap: { [key: string]: Observable<string> } = {}
  private objectUrls = new Map<number, string>()
  public fileType: 'images' | 'files'

  public onCancel: CallableFunction

  constructor(private fileReferenceService: FileReferenceService) { }

  /** S3-backed file references have an s3ObjectReferenceId and use negative IDs */
  private isS3File(fileReference: FileReference): boolean {
    return !!fileReference.s3ObjectReferenceId
  }

  registerFileURL(fileReferences: FileReference[]) {
    fileReferences.forEach(fileReference => {
      const key = fileReference.id
      if (this.isS3File(fileReference)) {
        this.fileURLMap[key] = this.fileReferenceService.getS3PresignedUrl(fileReference.s3ObjectReferenceId)
      } else {
        this.fileURLMap[key] = this.trackObjectUrl(
          key,
          this.fileReferenceService.getBlobUrlForFileReference(fileReference, this.assetFieldValue.assetID, 'asset')
        )
      }
    })
  }

  private trackObjectUrl(key: number, source$: Observable<string>): Observable<string> {
    return source$.pipe(
      tap(url => {
        const previousUrl = this.objectUrls.get(key)
        if (previousUrl && previousUrl !== url) URL.revokeObjectURL(previousUrl)
        this.objectUrls.set(key, url)
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    )
  }

  private revokeObjectUrls(): void {
    this.objectUrls.forEach(url => URL.revokeObjectURL(url))
    this.objectUrls.clear()
  }

  openFile(fileReference: FileReference) {
    this.fileReferenceService.openFile(fileReference, this.assetFieldValue.assetID, 'asset').subscribe()
  }

  openImageInNewTab(fileReference: FileReference) {
    this.fileReferenceService.openImageInNewTab(fileReference, this.assetFieldValue.assetID, 'asset').subscribe()
  }

  ngOnDestroy(): void {
    this.revokeObjectUrls()
  }


  _cancel() {
    if (this.onCancel) {
      this.onCancel()
    }

    this.modal?.hide()
  }
}
